
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import EntryDialog from '@/components/uicomp/ModalDialog-Form-Single'
import TableOptionsDialog from './ListOptionsDialog'
const components = {
  EntryDialog,
  TableOptionsDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
    opt: {},
    nlimitOptions: [
      { label: `10`, value: 10 },
      { label: `20`, value: 20 },
      { label: `50`, value: 50 },
      { label: `100`, value: 100 },
    ]
  }
}

/**
 * Computed
 *
 */
const computed = mapGetters({
  meta: `Product/TransactionItem/listMeta`,
  processing: `Product/TransactionItem/loadingState`
})

/**
 * Methods
 *
 */
const methods = mapActions({
  setListOption: `Product/TransactionItem/setListOption`,
})

methods.reset = function() {
  this.opt = Object.assign({}, this.meta)
}

methods.dismiss = function() {
  this.$refs.EntryDialog.dismiss()
}

methods.show = function() {
  this.$refs.EntryDialog.show()
  this.reset()
}

methods.save = async function() {
  this.setListOption({
    pagelimit: this.opt.pagelimit
  })
  this.dismiss()
}

/**
 * Watch
 *
 */
const watch = {
}

export default {
  components,
  data,
  computed,
  methods,
  watch,
}
</script>

<style scoped>
</style>

<template>
  <EntryDialog ref="EntryDialog" title="Table Setting" @submit="save">
    <FormGroup>
      <SelectField
        label="Record Per Page"
        :forceupper=true
        :options=nlimitOptions
        v-model="opt.pagelimit" />
    </FormGroup>
  </EntryDialog>
</template>